import React from 'react';

import FooterContainer from 'containers/footer/FooterContainer';
import { default as Navbar } from 'containers/navbar/NavbarContainer';

import vfalls4 from 'assets/img/stock/vfalls/vfalls_4.jpg'

export default () =>
    <div className="fullheight">
        <Navbar className="dark_start" />

        <section className="boxes themeBG">
            <div className="container-fluid">

                <div className="row">
                    <div
                        className="col-md-12 bordered_block grey_border image_bck m-t-120 p-t-30"
                        data-image={vfalls4}
                    >
                        <div
                            className="over"
                            data-opacity="0.5"
                            data-color="#292929"
                        />
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 wow fadeInLeft">
                                    <span className="great_title">
                                        Overview
                                    </span>
                                    <span className="great_subtitle great_subtitle_big" />
                                    <br />
                                    <span className="into_txt" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div className="row">
                <div className="col-md-10 col-md-offset-1">
                    <table className="table table-bordered table-striped dark-text">
                        <thead>
                            <tr>
                                <th>City</th>
                                <th>Timeline</th>
                                <th>Activities</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    Table Mountain: Capetown, South Africa
                                    <i>
                                        (Unesco world Heritage, one of the seven
                                        wonders of the world)
                                    </i>
                                </td>
                                <td>4 nights</td>
                                <td>
                                    <ul>
                                        <li>Table Mountain tour</li>
                                        <li>Cape Point tour</li>
                                        <li>Safari</li>
                                        <li>City and township tours</li>
                                        <li>Dining and cultural excursions</li>
                                        <li>Champagne cruises</li>
                                        <li>Wine tasting</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Victoria Falls: Zimbabwe & Zambia
                                    <i>
                                        (Unesco world Heritage, one of the seven
                                        natural wonders of the world)
                                    </i>
                                </td>
                                <td>4 nights</td>
                                <td>
                                    <ul>
                                        <li>Victoria Walking Falls tour </li>
                                        <li>Flight of Angels over the falls</li>
                                        <li>Zambezi River Sunset cruises</li>
                                        <li>
                                            Victoria Falls Safari Lodge Dinner
                                            and Waterhole Game overlook
                                        </li>
                                        <li>
                                            Victoria Falls National park game
                                            drive
                                        </li>
                                        <li>Hwange National Park Safari</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Okavango Delta: Botswana, Namibia, Zambia &
                                    Zimbabwe
                                    <i>
                                        (Unesco world Heritage, one of the seven
                                        natural wonders of the world)
                                    </i>
                                </td>
                                <td>1 night</td>
                                <td>
                                    <ul>
                                        <li>Chobe Safari</li>
                                        <li>Bird safari</li>
                                        <li>Canoing on Chobe River</li>
                                        <li>Local village excursion</li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
        <FooterContainer />
    </div>;



// WEBPACK FOOTER //
// ./src/pages/itinerary/overview/OverviewItinerary.jsx